import { Input, type Context } from '../receipt.machine.types';

export function generateInitialContext(input: Input): Context {
  return {
    receiptId: input.receiptId,
    order: undefined,
    error: undefined,
  };
}
